<template>
  <div>
    <div v-show="saved">
      <AnimatedCheckMark :done="saved"/>
      <p class="aligncenter">Votre rendez-vous est enregistré.<br><b>{{ creneau }}</b></p>
      <!--      <p class="aligncenter"><b>{{adresse.name}}</b> : {{adresse.address}} ({{adresse.access}})</p>-->
    </div>
    <div class="retrait" v-show="!saved">
      <form ref="form">
        <fieldset>
          <legend>{{ serverData.rdv }} :</legend>
          <div class="grid__label-input">
            <label for="prenom">Prénom</label>
            <input type="text" id="prenom" v-model="first_name" placeholder="Prénom..." required>
          </div>
          <div class="grid__label-input">
            <label for="nom">Nom</label>
            <input id="nom" type="text" v-model="last_name" placeholder="Nom..." required>
          </div>
          <div class="grid__label-input">
            <label for="email">Email</label>
            <input id="email" type="email" v-model="user_email" placeholder="Votre email..." required>
          </div>
          <div class="grid__label-input">
            <label for="phone">Téléphone</label>
            <input id="phone" type="text" v-model="billing_phone" placeholder="Votre téléphone..." maxlength="10"
              pattern="^(?:0|\(?\+33\)?\s?|0033\s?)[1-79](?:[\.\-\s]?\d\d){4}$" required>
          </div>
          <div class="grid__label-input" v-show="serverData.is_test">
            <label for="productId">Véhicule</label>
            <select id="productId" v-model.number="stockLineId">
              <option value="0">Je déciderai sur place</option>
              <option v-for="(vehicule, i) in serverData.demo_names" :value="i" :key="i">{{ vehicule }}</option>
            </select>
          </div>
          <div class="retrait__form--helper">
            <p><em>Choisissez un créneau disponible dans le calendrier &#x2192;</em></p>
          </div>
          <div>
            <template v-if="id === 14312">
              À Paris, vous pouvez aussi prendre un rdv d'essai au showroom <a href="/magasin/showroom-grandearmee/">Grande Armée</a>.
            </template>
            <template v-else-if="id === 14311">
              À Paris, vous pouvez aussi prendre un rdv d'essai aux showrooms
              <a href="/magasin/showroom-turbigo/">Turbigo</a> ou
              <a href="/magasin/showroom-grandearmee/">Grande Armée</a>.
            </template>
            <template v-else-if="id === 110221">
              À Paris, vous pouvez aussi prendre un rdv d'essai au showroom
              <a href="/magasin/showroom-turbigo/">Turbigo</a>.
            </template>
          </div>
        </fieldset>
      </form>
      <SvgSpinner v-show="!calCanMount"/>
      <div v-if="calCanMount">
        <VueCal class="vuecal--blue-theme" :hide-weekdays="[7]"
          :time-from="timeFrom" :time-to="19 * 60" :time-step="30"
          locale="fr" :disable-views="['years', 'year', 'month']"
          :selectedDate="selectedDate" :minDate="minDate"
          :events="events" v-on:view-change="viewChange"
          :on-event-click="eventClick" v-on:ready="viewChange">
          <template v-slot:no-event>Aucun créneau disponible</template>
        </VueCal>
        <div class="retrait__vuecal--overlay"></div>
      </div>
      <Modal>
        <transition name="fade" mode="out-in">
          <SvgSpinner :key="1" v-if="saving && !saved"/>
          <div :key="2" v-if="!saving && !saved">
            <p>Veuillez confirmer le rendez-vous :</p>
            <ul>
              <li>
                <h4>{{ creneau }}</h4>
              </li>
            </ul>
            <hr>
            <footer>
              <button class="button" @click="$store.dispatch('closeModal')">ANNULER</button>
              <button class="button" @click="save" ref="save">CONFIRMER</button>
            </footer>
          </div>
        </transition>
      </Modal>
    </div>
  </div>
</template>

<script>

import VueCal from 'vue-cal'
import 'vue-cal/dist/i18n/fr'
import 'vue-cal/dist/vuecal.css'
import Modal from "@/components/partials/Modal";
import SvgSpinner from "@/components/partials/SvgSpinner";
import AnimatedCheckMark from "@/components/partials/AnimatedCheckMark";
import LogRocket from 'logrocket';

export default {
  name: "RdvEssai",
  components: {AnimatedCheckMark, SvgSpinner, Modal, VueCal},
  data() {
    return {
      start: 0,
      saving: false,
      saved: false,
      creneau: '',
      creneauxDispo: [],
      serverData: {},
      vueCalCurrentView: {}, // store the vue-cal current view data
      calCanMount: false,
      first_name: '',
      last_name: '',
      user_email: '',
      billing_phone: '',
      intervalId: 0,
      stockLineId: 0,
    }
  },
  computed: {
    id() {
      return parseInt(g2rObj.postId)
    },
    creneauxSemaine() {
      if (16289 === parseInt(g2rObj.postId)) {
        return [
          '14:00 - 14:30',
          '14:30 - 15:00',
          '15:00 - 15:30',
          '15:30 - 16:00',
          '16:00 - 16:30',
          '16:30 - 17:00',
          '17:00 - 17:30',
          '17:30 - 18:00',
          '18:00 - 18:30',
        ]
      }
      return [
        '10:30 - 11:00',
        '11:00 - 11:30',
        '11:30 - 12:00',
        '12:00 - 12:30',
        '12:30 - 13:00',
        '13:00 - 13:30',
        '13:30 - 14:00',
        '14:00 - 14:30',
        '14:30 - 15:00',
        '15:00 - 15:30',
        '15:30 - 16:00',
        '16:00 - 16:30',
        '16:30 - 17:00',
        '17:00 - 17:30',
        '17:30 - 18:00',
        '18:00 - 18:30',
      ];
    },
    timeFrom() {
      if (16289 === parseInt(g2rObj.postId)) {
        return 14 * 60
      }
      return 10 * 60
    },
    /**
     * Set the date on which the calendar will do its first load, for example if today is thursday then load the calendar on Monday next week, otherwise customer sees a blank calendar as there is at least a one day gap.
     */
    selectedDate() {
      let today = new Date()
      if (today.getDay() === 6 || today.getDay() === 0) {
        today = today.addDays(8 - today.getDay())
      }
      return today
    },
    minDate() {
      let now = new Date()
      const add = now.getDay() === 6 ? 2 : 1;
      return now.addDays(add)
    },
    /**
     * The available slots being displayed in the vue-cal component
     */
    events() {
      return this.creneauxDispo.map(creneau => {
        return {
          start: `${creneau.substring(0, 16)}`, // '2019-07-20 09:00',
          end: `${creneau.substring(0, 10)} ${creneau.substring(19)}`,
          title: 'Créneau disponible',
          class: '',
          content: ''
        }
      })
    },
  },
  beforeMount() {
    // Get server data
    $api.get(`g2r/v1/storage/`, {params: {magasin_id: g2rObj.postId}})
      .then(response => response.data)
      .then(data => {
        // console.log(data)
        this.serverData = data
        this.calCanMount = true
      })
    // populate user data
    if (g2rObj.hasOwnProperty('userId')) {
      const userData = JSON.parse(document.querySelector(`[name="userData"]`).value);
      // console.log(userData)
      Object.keys(userData).forEach(key => this[key] = userData[key])
    }
  },
  methods: {
    massageMinutes(value) {
      return value === 0 ? '00' : value;
    },
    range(n) {
      return [...Array(Math.ceil(n)).keys()]
    },
    viewChange(payload) {
      if (this.intervalId > 0) {
        clearInterval(this.intervalId);
      }
      this.vueCalCurrentView = payload
      this.reset()
      this.gapiCheckWeek(payload)
      // Reload automatically every 30 seconds to avoid duplicate in slots
      this.intervalId = setInterval(this.reload, 30000)
    },
    reload() {
      this.reset();
      this.gapiCheckWeek(this.vueCalCurrentView)
    },
    reset() {
      this.creneauxDispo = []
    },
    eventClick(vueCalEvent) {
      if (this.$refs.form.checkValidity()) {
        this.start = vueCalEvent.start.format('YYYY-MM-DD HH:mm');
        this.creneau = `${vueCalEvent.start.format(`dddd DD MMMM YYYY`)} de ${vueCalEvent.start.format(`HH:mm`)} à ${vueCalEvent.end.format(`HH:mm`)}`
        this.$store.dispatch('openModal')
      } else {
        this.$refs.form.reportValidity()
      }
    },
    gapiCheckWeek(payload) {
      let now = new Date()
      let min = payload.startDate
      // console.log(min.toISOString())
      if (payload.startDate.getTime() < now.getTime()) {
        const add = now.getDay() === 6 ? 2 : 1;
        min = now.addDays(add)
        min.setHours(8) // Important ! otherwise only the events after the current time are returned and this displays available slots when they're not (hence double entries)
      }
      // console.log(min.format())
      const vm = this;
      $api.post(`g2r/v1/calendar/event/list`, {
        calendarId: vm.serverData.calendar_id,
        timeMin: min.toISOString(),
        timeMax: payload.endDate.toISOString(),
        showDeleted: false,
        singleEvents: true,
        maxResults: 80,
        orderBy: 'startTime',
      })
        .then(response => response.data)
        .then(data => { // data is events array
          let creneauxPris = [] // taken slots in calendar
          const days = new Set() // days which have an existing event in calendar
          let dayOfTheWeek = new Date(min)
          while (dayOfTheWeek.getTime() < payload.endDate.getTime()) {
            days.add(dayOfTheWeek.format())
            dayOfTheWeek = dayOfTheWeek.addDays(1)
          }
          const blockedDays = new Set() // days blocked in calendar
          // const eventsPerDayArray = []
          data.forEach(event => {
            if (null !== event.start.dateTime && null !== event.end.dateTime) {
              let start = new Date(event.start.dateTime);
              const end = new Date(event.end.dateTime);
              const duration = (end - start) / 1000;
              if (duration > 600) {
                // Split into 1/2H chuncks
                vm.range(duration / 60 / 30).forEach(() => {
                  let string = `${start.format()} ${start.getHours()}:${vm.massageMinutes(start.getMinutes())}`;
                  start = new Date(start.setTime(start.getTime() + (30 * 60 * 1000)));
                  string = `${string} - ${start.getHours()}:${vm.massageMinutes(start.getMinutes())}`;
                  creneauxPris.push(string);
                })
              } else {
                const string = `${start.format()} ${start.getHours()}:${vm.massageMinutes(start.getMinutes())} - ${end.getHours()}:${vm.massageMinutes(end.getMinutes())}`;
                creneauxPris.push(string);
                // eventsPerDayArray.push(start.format())
              }
            } else {
              blockedDays.add(new Date(event.start.date).getDay())
            }
          }) // End forEach
          /**
           * Check the number of events, per day, block the day if needed
           * pas plus de 4 retraits par jour sauf mardi et jeudi
           */
          /*let eventsPerDay = eventsPerDayArray.reduce((prev, cur) => {
            prev[cur] = (prev[cur] || 0) + 1;
            return prev;
          }, {});
          Object.keys(eventsPerDay).forEach(day => {
            const d = new Date(day)
            if (([2, 4].includes(d.getDay()) && eventsPerDay[day] >= 4)
              || (![2, 4].includes(d.getDay()) && eventsPerDay[day] >= 4)) {
              days.delete(day)
            }
          })*/
          // console.log(blockedDays, days)

          /**
           * Generate the base creneauxDispo array out of the opened days defined in Storage Model
           */
          let weekDays = new Map();
          weekDays.set(min.getDay(), min.format());
          vm.serverData.days.forEach(day => {
            if (day > min.getDay()) {
              weekDays.set(day, min.addDays(day - min.getDay()).format());
            }
          })
          /**
           * Remove google calendars blocked days before looping over each day
           */
          blockedDays.forEach(blockedDay => weekDays.delete(blockedDay))
          /**
           * Generate all the default available slots
           */
          weekDays.forEach(day => {
            let string = ``;
            vm.creneauxSemaine.forEach(creneau => {
              string = `${day} ${creneau}`;
              vm.creneauxDispo.push(string)
            })
          })
          /**
           * Remove the taken slots
           */
          vm.creneauxDispo = vm.creneauxDispo.filter(creneau => !creneauxPris.includes(creneau));
        })
    },
    logTestDriveEvent() {
      // Use fetch() instead of $api to prevent errors triggering an alert,
      fetch('/wp-json/g2r/v1/test-drive/calendar/log', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.user_email,
          phone: this.billing_phone,
          reserved_test_at: this.start,
          storage_id: this.serverData.ID,
          stock_line_id: this.stockLineId,
        })
      })
    },
    save() {
      if (!this.saving) {
        this.saving = true;
        $api.post(`g2r/v1/calendar/event/`, {...this.$data, magasin_id: g2rObj.postId, essai: true})
          .then(response => response.data)
          .then(data => {
            if (!data) {
              alert(`Un problème a empêché l'enregistrement du rendez-vous ! Nous vous invitons à recharger la page puis re-essayer, ou à nous contacter par téléphone si le problème persiste.`)
            } else {
              this.saved = true
              // Silently log this entry
              this.logTestDriveEvent()
            }
          })
          .finally(() => {
            this.saving = false
            this.$store.dispatch('closeModal')
          })
      }
    },
  },
  beforeDestroy() {
    if (this.intervalId > 0) {
      clearInterval(this.intervalId);
    }
  }
  // mounted() {
  //   if ('https://www.go2roues.com' === window.location.origin) {
  //     LogRocket.init('clvege/production-store');
  //     LogRocket.identify(g2rObj.userId, {
  //       name: g2rObj.userName,
  //       email: g2rObj.userEmail,
  //     });
  //   }
  // },
}
</script>

<style scoped lang="scss">

[v-cloak] {
  display: none;
}

.retrait {
  margin-top: 2rem;

  form {
    align-self: center;
    margin-bottom: 3rem;

    fieldset {
      padding: 2rem;

      .grid__label-input {
        display: grid;
        grid-template-columns: 1fr 3fr;
        grid-column-gap: 2%;
        margin-bottom: 1rem;

        label {
          align-self: center;
          justify-self: end;
          line-height: 1;
        }

        input, select {
          margin-bottom: 0;
        }
      }

      .retrait__form--helper {
        text-align: right;
      }
    }
  }

}

@media screen and (min-width: 768px) {
  .retrait {
    display: grid;
    grid-template-columns: 1fr 1.8fr;
    grid-column-gap: 2%;
  }

  form {
    margin-bottom: 0;
  }
}

</style>

<style lang="scss">

.retrait {
  .vuecal {
    height: 500px;
  }

  .vuecal__weekdays-headings {
    font-size: 1.2rem;
  }

  .vuecal__cell.disabled {
    background: repeating-linear-gradient(45deg,
      #fdfdfd,
      #fdfdfd 10px,
      #f7f7f7 10px,
      #f7f7f7 20px);

    .vuecal__no-event {
      opacity: 0;
    }
  }

  .vuecal__no-event {
    line-height: 1;
    font-size: 1rem;
    color: var(--dark-blue);
    font-style: italic;
  }

  .vuecal__event-title, .vuecal__event-time {
    font-size: 1rem;
  }

  .vuecal__event {
    cursor: pointer;
    padding: 5px;
    color: var(--dark-blue);
  }

  .vuecal:not(.vuecal--dragging-event) .vuecal__event:hover {
    background-color: rgba(0, 165, 188, .1);
  }

  .vuecal__time-column .vuecal__time-cell {
    .label {
      color: var(--dark-blue);
      font-size: 1.2rem;
    }
  }

  .vuecal__header button {
    &:focus, &:hover {
      background-color: rgba(0, 165, 188, .33);
    }
  }

  .modal-content {
    h4 {
      margin-top: 0;
    }

    footer {
      text-align: right;

      button {
        padding: 1rem 2rem;
        font-size: 1.3rem;

        &:first-child {
          margin-right: 1rem;
        }
      }
    }

    .animation-ctn {
      margin-top: 1rem;
    }
  }
}

// transitions
.fade-enter-active, .fade-leave-active {
  transition: opacity .1s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>
